import * as React from "react"

function TrendUp(props) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.1 27L3 24.9L14.1 13.725L20.1 19.725L27.9 12H24V9H33V18H30V14.1L20.1 24L14.1 18L5.1 27Z" fill={props?.color ?? "#D7DEE6"} />
    </svg>
  )
}

export default TrendUp
